/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private messages = [];

  private messageSubjects = new Map<string, Subject<any>>();

  constructor() {
    for (const message of this.messages) {
      this.messageSubjects.set(message, new Subject());
    }
  }

  broadcast(name: string, data?: any) {
    this.checkMessageValidity(name);
    this.messageSubjects.get(name).next(data);
  }

  on(name: string): Observable<any> {
    this.checkMessageValidity(name);
    return this.messageSubjects.get(name).asObservable();
  }

  unsubscribe(key) {
    this.messageSubjects.get(key) && this.messageSubjects.get(key).complete();
    this.messageSubjects.delete(key);
  }

  unsubscribeAll() {
    this.messageSubjects.forEach((subject: Subject<any>) => {
      subject.complete();
    });

    this.messageSubjects.clear();
  }

  private checkMessageValidity(name: string) {
    if (!this.messageSubjects.has(name)) {
      this.messageSubjects.set(name, new Subject());
    }
  }

  getMessageSubjects() {
    return this.messageSubjects;
  }
}
